export default __webpack_public_path__ + "static/slide2-12f050ce4a742af67b0895b36fcf5f85.jpg";